import React from 'react';

const Loading = () => {
  return (
    <div className='text-center center-absolute'>
      <div className='spinner-border text-danger' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
      <div>Loading wait...</div>
    </div>
  );
};

export default Loading;
